import {useFaceDetection} from "react-use-face-detection";
import FaceDetection from "@mediapipe/face_detection";
import React, {useEffect,useState} from "react";
import {Col, Row} from "reactstrap";
import {Button, Button as SementicBtn, Form} from "semantic-ui-react";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import * as common from "../../../const/Common/CommonFunc";
import './style.css';
import * as actionCreators from "../../../store/Action";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import Spinner from "../../Spinner/Spinner";

const WebCameraWithFR = (props) => {
  const [pending,setPending] = useState(0);

  const { imgRef, boundingBox, isLoading, detected, facesDetected } = useFaceDetection({
    faceDetectionOptions : {
      model: 'short'
    },
    faceDetection: new FaceDetection.FaceDetection({
      locateFile: (file) => {
        return `/face_detection/${file}`
      },
    }),
  });

  const screenShotHandler = () => {
    if (!detected) {
      common.notifyMessage("Face detection failed!");
      return;
    }
    props.imageUpload(props.screenshot);
  }

  const retakeImageHandler = () => {
    props.retakeImage(true);
  }

  useEffect(()=>{
    const pendingTimeId = setTimeout(()=>{
      setPending(1);
    },1500);

    return () => clearTimeout(pendingTimeId);
  },[detected]);

  return (
    <MDBModal isOpen={props.isOpen} toggle={() => {
    }} size="md" className={"user-verification-modal guest-reg-form"}>
      <MDBModalHeader style={{padding: '5px'}}>
        Profile Picture Verification
      </MDBModalHeader>
      <MDBModalBody>
        <img src={props.screenshot} style={{
          width: '200px',
          height: '150px',
          objectFit: 'scale-down',
          // border: '1px #9a9a9a dotted',
          boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
        }}
             ref={imgRef}
        />
        {pending === 0 && <div className={'d-flex align-items-center justify-content-center fr-spinner'}>
          <div className="ui segment spinner-div" id="data-fetch-loader" >
            <div className="ui active inverted dimmer">
              <div className="ui text loader">
              </div>
            </div>
          </div>
        </div>}
        {pending === 1 && <Row>
          {detected ?
            <p className={'success-text'}>Face detected successfully</p> :
            <p className={'warning-text'}>Face detection failed</p>
          }
          <Col className={'align-center'}>
            {(detected || !detected) && <SementicBtn style={{width: "25%"}} className={"retry-btn"}
                                                     onClick={retakeImageHandler}
            >Retry</SementicBtn>}
            {detected && <SementicBtn style={{width: "30%"}} className="px-5 search-visitor-btn"
                                      onClick={screenShotHandler}
            >Confirm</SementicBtn>}
          </Col>
        </Row>}
      </MDBModalBody>
    </MDBModal>
  );

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  all_available_card: state.reception_SheduleMeetingReducer.all_available_card,
});

const mapDispatchToProps = (dispatch) => {
  return {
    imageUploaderHandler: (image) => dispatch(actionCreators.imageUploaderHandler(image)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data))
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(WebCameraWithFR);
